// extracted by mini-css-extract-plugin
export default {"content":"ComboCampaignEditComponents_content__frWve"};